<template>
  <DetailContainer>
    <PageHeader
      slot="page-header"
      showBack
      showBreadcrumb
      @back="$router.push({ name: 'Device' })"
    ></PageHeader>
    <div slot="top" class="info">
      <div class="info-content">
        <div class="info-header">
          <div class="status-icon">
            <hl-status
              class="online"
              :iconClass="(onOffLineStatus[info.online] || {})['iconClass']"
              :color="(onOffLineStatus[info.online] || {})['color']"
              :title="info.onlineName"
            ></hl-status>
            <!--            <div class="device">-->
            <!--              <hl-status-->
            <!--                class="device-dot"-->
            <!--                :color="(deviceStatus[info.state] || {})['color']"-->
            <!--                :title="info.stateName"-->
            <!--              ></hl-status>-->
            <!--            </div>-->
          </div>
          <div>
            <h3 class="name">{{ info.code | format }}</h3>
            <div class="address">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-address"></use>
              </svg>
              {{ info.installationAreaName | format }}
            </div>
          </div>
        </div>
        <div class="info-desc">
          <Descriptions :gutter="24">
            <DescriptionsItem labelWidth="auto" :label="$t('Device.customerName')">
              {{ info.customerName | format }}
            </DescriptionsItem>
            <DescriptionsItem labelWidth="auto" :label="$t('Device.warrantyPeriod')">
              <span id="warrantyPeriod" style="margin-right: 4px">
                {{ info.warrantyPeriod | format }}
              </span>
              {{ $t('Device.unitDay') }}

              <!--            <svg-->
              <!--              class="icon icon-copy"-->
              <!--              aria-hidden="true"-->
              <!--              data-clipboard-target="#deviceCode"-->
              <!--              id="copyDeviceCode"-->
              <!--            >-->
              <!--              <use xlink:href="#icon-copy"></use>-->
              <!--            </svg>-->
            </DescriptionsItem>
            <DescriptionsItem labelWidth="auto" :label="$t('Device.installationTime')">
              {{ info.installationTime | formatTime }}
            </DescriptionsItem>
            <DescriptionsItem labelWidth="auto" :label="$t('Device.deadline')">
              {{ info.expirationDate | formatTime }}
            </DescriptionsItem>
            <DescriptionsItem labelWidth="auto" :label="$t('Device.WIFIDTUModel')">
              {{ info.version | format }}
            </DescriptionsItem>
            <DescriptionsItem labelWidth="auto" :label="$t('Common.lastCommunicationTime')">
              {{ info.lastCommunicationTime | formatTime }}
            </DescriptionsItem>
            <DescriptionsItem labelWidth="auto" :label="$t('Device.productModel')">
              {{ info.productName | format }}
            </DescriptionsItem>
            <DescriptionsItem labelWidth="auto" :label="$t('Device.factoryArea')">
              {{ info.factoryArea | format }}
            </DescriptionsItem>
          </Descriptions>
        </div>
      </div>
      <div class="deviceStatus" v-if="info.online === 'online'">
        <!--  Run  1      -->
        <Cooking
          :row="deviceCookStatus"
          v-if="deviceCookStatus.state === 1 && !cookStatusLoading"
        />
        <!--  MultiTimer    5      -->
        <LayerTiming
          :row="deviceCookStatus"
          v-if="deviceCookStatus.state === 5 && !cookStatusLoading"
        />
        <!--  Cool    4      -->
        <Cooling
          :row="deviceCookStatus"
          v-if="deviceCookStatus.state === 4 && !cookStatusLoading"
        />
        <!--  Cleaned    2     -->
        <Washing
          :row="deviceCookStatus"
          v-if="deviceCookStatus.state === 2 && !cookStatusLoading"
        />
        <Error
          :row="deviceCookStatus"
          v-if="deviceCookStatus.state === 'error' && !cookStatusLoading"
        />
        <!--  Stop      0     -->
        <Await :row="deviceCookStatus" v-if="deviceCookStatus.state === 0 && !cookStatusLoading" />
      </div>
    </div>

    <DeviceDetailTable :productKey="info.productKey" :deviceCode="info.code" />
  </DetailContainer>
</template>

<script>
let client = null
let timer = null
import ClipboardJS from 'clipboard'
import DetailContainer from '@/components/DetailContainer/index'
import Descriptions from '@/components/Descriptions'
import DescriptionsItem from '@/components/Descriptions/DescriptionsItem'
import Status from '@/components/CommonTable/Status'
import DeviceDetailTable from './DetailTable/index'
import { format, formatTime, formatNumWithComma } from '@/utils/utils'
import { deviceStatus, onOffLineStatus } from '@/config/status'
import { productTypeTag } from '@/config/tag'
import { createMqttClient, topicPrefix } from '@/utils/mqttClient'
import Cooking from './deviceStatus/Cooking'
import LayerTiming from './deviceStatus/LayerTiming'
import Cooling from './deviceStatus/Cooling'
import Washing from './deviceStatus/Washing'
import Error from './deviceStatus/Error'
import Await from './deviceStatus/Await'
import i18n from '@/locales/index'
const mqttState = {
  loading: 'loading',
  fail: 'fail',
  success: 'success'
}
const mqttStateNameEnum = {
  loading: i18n.t('Common.loading'),
  fail: i18n.t('Common.connFail'),
  success: i18n.t('Common.connSuccess')
}
export default {
  components: {
    DetailContainer,
    Descriptions,
    DescriptionsItem,
    'hl-status': Status,
    DeviceDetailTable,
    Cooking,
    LayerTiming,
    Cooling,
    Washing,
    Error,
    Await
  },

  data() {
    return {
      mqttState,
      mqttConnectState: mqttState.loading,
      deviceStatus,
      onOffLineStatus,
      productTypeTag,
      info: {},
      deviceId: this.$route.query.id,
      activeTabName: 'first',
      //downTopic: `${topicPrefix}mqtt/${this.$route.query.id}/down`,
      downTopic: '',
      upTopic: '',
      deviceCookStatus: {
        stateName: '' //\"cooking\",\"washing\",\"cooling\",\"layerTiming\",\"error\",\"await\",\"fault\",\"alarm\",\"normal\"
      },
      cookStatusLoading: false
    }
  },
  created() {
    this.getDeviceDetail()
  },
  mounted() {
    this.deviceClipboard = new ClipboardJS('#copyDeviceCode')
    // this.onClipboard(this.deviceClipboard)
    this.communicationClipboard = new ClipboardJS('#copyCommunicationCode')
    // this.onClipboard(this.communicationClipboard)
  },
  destroyed() {
    this.deviceClipboard.destroy()
    this.deviceClipboard.destroy()
    client.unsubscribe(this.upTopic)
    timer && clearTimeout(timer)
  },
  filters: {
    format,
    formatTime,
    formatNumWithComma
  },
  methods: {
    getDeviceDetail() {
      const params = {
        id: this.deviceId
      }
      return this.$ajax
        .get(this.$api.device.device_detail, params)
        .then((res) => {
          this.info = res.data
          this.deviceCookStatus = {
            currStepNum: res.data.currStepNum,
            currStepType: res.data.currStepType,
            detergentSurplus: res.data.detergentSurplus,
            menuName: res.data.menuName,
            softenerSurplus: res.data.softenerSurplus,
            state: res.data.state,
            totalWater: res.data.totalWater,
            totalElectric: res.data.totalElectric,
            totalStepNum: res.data.totalStepNum,
            totalWorkTime: res.data.totalWorkTime
          }
          this.upTopic = `${topicPrefix}mqtt/${res.data.communicationCode}/state`
          this.downTopic = `${topicPrefix}mqtt/${res.data.communicationCode}/down`
          if (res.data.online === 'online') {
            this.$nextTick(() => {
              this.connectMqttService()
            })
          }
        })
        .catch(() => {})
    },
    connectMqttService() {
      client = createMqttClient(this, onMessage(this), onConnect(this), onError(this))
      this.upTopicCmd()
    },
    upTopicCmd() {
      console.log('upTopicCmd', this.upTopic)
      let cmd = {
        cmd: 'state'
      }
      console.log(3)
      client.publish(this.downTopic, JSON.stringify(cmd))
      client.subscribe(this.upTopic)
      this.cookStatusLoading = true
      timer = setTimeout(() => {
        console.log(4)
        this.cookStatusLoading = false
        this.$message.error(`${this.$t('Common.deviceConnMessage')}`)
        //client.unsubscribe(this.upTopic)
        // this.receiveMessagList.push('下发失败')
      }, 60000)
    },
    // onClipboard(clipboard) {
    //   clipboard.on('success', (e) => {
    //     this.$message.success('复制成功')
    //     e.clearSelection()
    //   })
    //   clipboard.on('error', () => {
    //     this.$message.success('复制失败')
    //   })
    // },
    // copyToBorad(selector) {
    //   navigator.clipboard
    //     .readText()
    //     .then((clipText) => (document.querySelector(selector).innerText += clipText))
    // },
    copyCode() {
      console.log(1111)
      // this.copyToBorad('.deviceCode')
    }
  }
}
function onConnect(self) {
  return function() {
    self.mqttConnectState = mqttState.success
    console.log(5)
  }
}
function onError(self) {
  return function() {
    self.mqttConnectState = mqttState.fail
    console.log(6)
  }
}
function onMessage(self) {
  self.cookStatusLoading = true
  console.log(1)
  return function(topic, message) {
    console.log('message2', topic)
    console.log('message', message.toString())
    let payload
    try {
      payload = JSON.parse(message.toString(), null, 2)
    } catch (err) {
      /* eslint-disable-next-line */
      payload = {}
    } finally {
      self.cookStatusLoading = false
    }
    console.log('payload', payload)
    if (payload)
      if (payload.params) {
        self.deviceCookStatus = {
          ...payload.params
        }
        // client.unsubscribe(self.upTopic)
        // timer && clearTimeout(timer)
        // self.cookStatusLoading = false
      }
  }
}
</script>

<style lang="scss" scoped>
.info {
  display: flex;
  .info-content {
    width: 70%;
    .info-header {
      display: flex;
      margin-bottom: 40px;
      .status-icon {
        position: relative;
        width: 24px;
        height: 24px;
        margin-right: 14px;
        .device {
          position: absolute;
          width: 16px;
          height: 16px;
          background-color: #fff;
          border-radius: 50%;
          right: -8px;
          bottom: -5px;
        }
        .device-dot {
          position: absolute;
          left: 2px;
          top: 2px;
        }
      }
      .name {
        margin-right: 8px;
        font-size: 24px;
        color: #333333;
      }
      .address {
        margin-top: 13px;
        color: #333333;
        font-weight: 500;
        .icon {
          width: 12px;
          color: #a1a5ad;
        }
      }
    }
    .icon-copy {
      margin-left: 5px;
      color: $--color-blue;
      cursor: pointer;
    }
  }
  .deviceStatus {
    width: 30%;
    display: flex;
    justify-content: right;
    align-items: center;
    //.deviceShadow {
    //  width: 332px;
    //  height: 208px;
    //  border-radius: 16px;
    //  border: 1px solid #dcdfe6;
    //}
  }
}
</style>
